import React, {lazy, useMemo} from 'react';
import {getThemeName} from "../../utils/themeUtils";
import { useLingui } from '@lingui/react/macro';

// React's useMemo does not guarantee caching, if this becomes a practical problem, this should be rewritten
// using a custom useCachedLazy hook that will keep track of the already imported with a Map
function ThemableComponent(props) {
    const themeName = getThemeName();
    const {t} = useLingui();

    const Component = useMemo(() =>
        lazy(() =>
            import(`./${themeName}/${props.componentName}`).catch(() =>
                import(`./MissingComponent`)
            )),
        [props.componentName]);

    // A <span> fallback element was still causing (rare) cases of "removeChild()" issue when translator ignored translate="no" attribute
    // wrapping it into a div *should* make it go away fully.
    // TODO - revisit this once the data from actual prod usage shows success/failure
    return (
        <React.Suspense fallback={<div translate="no">{t({id: "loading"})}...</div>}>
            <Component {...props}/>
        </React.Suspense>
    );
}

export default ThemableComponent;